import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function SoldIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M1 2V16H23V2H1ZM3 14V4H10.1429L20.8571 14H3ZM16.5572 4H21V7.93219L16.5572 4ZM4 17.5117H6V22H4V17.5117ZM18 17.5117H20V22H18V17.5117Z",
    fill: "currentColor"
  }));
}